import React, { useState, useEffect } from "react";

const SLIDE_INTERVAL_MS = 5000;

export const Header = (props) => {
  const images =
    props.gallery && props.gallery.length
      ? props.gallery.map((item) => item.largeImage)
      : ["img/intro-bg.jpg"];

  const [current, setCurrent] = useState(0);

  // Auto-advance through the images in a loop; no manual controls.
  useEffect(() => {
    if (images.length < 2) return undefined;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, SLIDE_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [images.length]);

  // If the image set shrinks (e.g. data just finished loading), keep the index valid.
  useEffect(() => {
    if (current >= images.length) setCurrent(0);
  }, [images.length, current]);

  return (
    <header id="header">
      <div className="intro">
        <div className="intro-carousel">
          {images.map((src, i) => (
            <div
              key={src}
              className={
                "intro-carousel-slide" + (i === current ? " active" : "")
              }
              style={{ backgroundImage: `url(${src})` }}
            />
          ))}
        </div>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <h2 className="intro-subtitle">
                  {props.data ? props.data.subtitle : "Loading"}
                </h2>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#contact"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Get a Quote
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
